import { loadUseLocale, useDynamicLocale } from '@/hoslog-intl';
import { setApiLocale } from '@/services/client/apiLocale';
import React, { ReactNode, useEffect, useState } from 'react';
import { persistLocaleCookie } from './localeCookie';

interface LocaleLoaderProps {
  children: ReactNode;
}

const LocaleSync: React.FC<LocaleLoaderProps> = ({ children }) => {
  const { locale } = useDynamicLocale();
  setApiLocale(locale);

  persistLocaleCookie(locale);

  return <>{children}</>;
};

const LocaleLoader: React.FC<LocaleLoaderProps> = ({ children }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    void loadUseLocale().then(() => setLoaded(true));
  }, []);

  if (!loaded) return null;

  return <LocaleSync>{children}</LocaleSync>;
};

export default LocaleLoader;
